// removed by extract-text-webpack-plugin
module.exports = {"headline":"Headline__headline--2AbDE","bounce":"Headline__bounce--1Tvo7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Headline/Headline.css
// module id = ./src/components/Library/Headline/Headline.css
// module chunks = 4